import { searchTrials } from "helper/icons";

const SearchBar = (props) => {
  const { placeholder, onChange, width = "w-96" } = props || {};

  return (
    <div className="relative">
      <input
        type="text"
        placeholder={placeholder}
        onChange={onChange}
        // className="inputFocus  bg-opacity-50 bg-white text-base text-gray-500 w-[90vw] md:w-40 lg:w-96 font-medium focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg h-11 pl-4 pr-4 block"
        className={`${width} inputFocus bg-white text-base text-gray-500   font-medium focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg h-11 pl-4 pr-4 block`}
      />
      <div className="absolute inset-y-0 right-2 pr-3 flex items-center pointer-events-none">
        <img src={searchTrials} alt="" className="w-5 h-5" />
      </div>
    </div>
  );
};

export default SearchBar;
